module.exports = __webpack_public_path__ + "static/media/4.9f2e61cb.gif";